module.exports = __webpack_public_path__ + "static/media/canceled.a690e1de.svg";